import type { FileVersionRouter } from "replo-publisher/src/trpc/routers/fileVersion";

import { getNamespacedQueryClient } from "@v2/trpc/trpc";

import { createTrpcRouterConfig } from "../config";

const {
  router: fileVersionRouter,
  client: fileVersionClient,
  utils: fileVersionUtils,
  options: fileVersionOptions,
} = createTrpcRouterConfig<FileVersionRouter>({
  path: "fileVersion",
  queryClient: getNamespacedQueryClient("fileVersion"),
});

export {
  fileVersionClient,
  fileVersionRouter,
  fileVersionUtils,
  fileVersionOptions,
};
